module.exports = __webpack_public_path__ + "static/media/ConnectPin.f4a107d1.svg";